import classNames from 'classnames'

export const Line = (props: { className?: string }) => {
  const { className } = props

  return (
    <div className={classNames('w-full flex justify-center', className)}>
      <div className={' border-r-1 w-0 h-[45px] border-gray-extra-light'} />
    </div>
  )
}
